export default __webpack_public_path__ + "static/media/culture_EP11.2478fa34.png";